import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliError, Text } from '@lili/lili-frontend-common';
import DigitsContainer from '../../../../../generic-components/DigitsContainer';
import { LOGIN_ERRORS } from '../../../../../flows/login/constants/messages';
import Button from '../../../../../generic-components/Button';
import { convertToTimeFormat } from '../../../../../helpers/currency.helper';

interface InviteMFAInputProps {
  numberOfDigits: number;
  mfaDestination?: string;
  errorMessage?: string;
  timeLeft: number | null;
  onResendClick: () => void;
  handleMfaCode: (mfaCode: string) => void;
  isLoading: boolean;
}

export const InviteMFAInput = ({
  numberOfDigits,
  mfaDestination,
  errorMessage,
  timeLeft,
  onResendClick,
  handleMfaCode,
  isLoading,
}: InviteMFAInputProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col justify-center px-[40px] pb-[24px] pt-[40px] rounded-lg bg-surface-primary-bw-00 fadeIn max-w-[420px] '>
      <Heading.H5 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary text-left'>
        {t('INVITE_ACCOUNTANT.VERIFY_PHONE.MAIN_TITLE')}
      </Heading.H5>
      <Heading.H9 className='text-text-main-primary mt-[8px] mb-[12px] text-left '>
        {t('INVITE_ACCOUNTANT.VERIFY_PHONE.DESCRIPTION', { destination: mfaDestination })}
      </Heading.H9>
      <DigitsContainer
        numOfDigits={numberOfDigits}
        onFulfill={handleMfaCode}
        isError={!!errorMessage}
        isLoading={isLoading}
      />
      {errorMessage && (
        <div className='flex justify-center w-full mb-4'>
          <LiliError errorMessage={t(LOGIN_ERRORS.BAD_REQUEST)} showIcon />
        </div>
      )}
      {!timeLeft && (
        <Button
          onClick={onResendClick}
          className='mt-[14px]  font-metricR w-full text-action03 hover:text-action04'
          title={t('ACCOUNTANT_OB.VERIFY_PHONE.CTA')}
          id='initResend'
        />
      )}
      {timeLeft && (
        <div className='flex items-center gap-[4px]'>
          <Heading.H10 className='text-text-main-tertiary'>{t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND_TIMER')}</Heading.H10>
          <Heading.H10 className='text-[14px] text-text-brand-primary'>{convertToTimeFormat(timeLeft)}</Heading.H10>
        </div>
      )}
      <Text.H11 className='text-text-main-tertiary mt-[28px] text-center w-full'>
        {t('VERIFICATION_CODE_PAGE_FOOTER')}
      </Text.H11>
    </div>
  );
};
